<template>
  <section class="esop-details">
    <div class="esop-details-container">
      <!-- Header -->
      <div class="esop-details-header">
        <button class="back-btn" @click="$router.back()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="header-content">
          <h1 class="page-title">Configure ESOP</h1>
          <p class="page-subtitle">Manage your employee stock option plan settings</p>
        </div>
      </div>

      <!-- Tabs -->
      <div class="tabs-wrapper">
        <div class="tabs-container">
          <button
            v-for="(opt, index) in options"
            :key="index"
            class="tab-btn"
            :class="{ active: option === opt }"
            @click="emitOption(opt)"
          >
            {{ opt }}
          </button>
        </div>
      </div>

      <!-- Content -->
      <div class="esop-details-content">
        <div v-if="form === 'Asset Details'" class="forms-container">
          <AssetInfoForm @dropdown-title="setActiveDropdown" />
          <InvestmentMemoForm @dropdown-title="setActiveDropdown" />
          <TokenDetailAddressForm @dropdown-title="setActiveDropdown" />
          <FoundersForm @dropdown-title="setActiveDropdown" />
          <SocialsForm @dropdown-title="setActiveDropdown" />
        </div>
        <div v-if="form === 'Share Details'" class="forms-container">
          <EsopTokenForm :prefill="prefill" buttonText="Save Changes" />
          <VestingSchedule
            buttonText="Save Changes"
            :prefill="prefill"
            class="vesting-schedule-form"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EsopTokenForm from "@/components/employeesBenefit/forms/EsopTokenForm";
import VestingSchedule from "@/components/employeesBenefit/forms/VestingSchedule";
import AssetInfoForm from "@/components/asset/forms/AssetInfoForm.vue";
import InvestmentMemoForm from "@/components/asset/forms/InvestmentMemoForm.vue";
import TokenDetailAddressForm from "@/components/asset/forms/TokenDetailAddressForm.vue";
import FoundersForm from "@/components/asset/forms/FoundersForm.vue";
import SocialsForm from "@/components/asset/forms/SocialsForm.vue";
import { computed } from "vue-demi";

export default {
  name: "EsopDetails",
  components: {
    EsopTokenForm,
    VestingSchedule,
    AssetInfoForm,
    InvestmentMemoForm,
    TokenDetailAddressForm,
    FoundersForm,
    SocialsForm,
  },
  data() {
    return {
      prefill: false,
      form: "Asset Details",
      option: "Asset Details",
      options: ["Asset Details", "Share Details"],
      activeDropdown: "",
    };
  },
  provide() {
    return {
      activeDropdown: computed(() => this.activeDropdown),
    };
  },
  computed: {
    ...mapGetters("Esop", ["vestingSchedule", "esopToken"]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions("Esop", ["getVestingSchedule", "getEsopToken"]),
    async fetchData() {
      try {
        await Promise.all([this.getVestingSchedule(), this.getEsopToken()]);
        this.prefill = true;
      } catch (error) {}
    },

    setActiveDropdown(title) {
      this.activeDropdown = title;
    },

    emitOption(opt) {
      this.option = opt;
      this.form = opt;
    },
  },
};
</script>

<style lang="scss" scoped>
.esop-details {
  min-height: 100vh;
  background: #F8FAFC;
  padding: 24px 16px;

  @media screen and (min-width: 768px) {
    padding: 32px 40px;
  }
}

.esop-details-container {
  max-width: 900px;
  margin: 0 auto;
}

.esop-details-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 32px;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  color: #0F172A;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #F1F5F9;
    border-color: #CBD5E1;
  }
}

.header-content {
  flex: 1;
}

.page-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #0F172A;
  margin: 0 0 4px 0;
  line-height: 1.3;

  @media screen and (min-width: 768px) {
    font-size: 28px;
  }
}

.page-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #64748B;
  margin: 0;
}

.tabs-wrapper {
  margin-bottom: 24px;
}

.tabs-container {
  display: flex;
  gap: 8px;
  padding: 4px;
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  width: fit-content;
}

.tab-btn {
  padding: 10px 20px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #64748B;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover:not(.active) {
    color: #0F172A;
    background: #F8FAFC;
  }

  &.active {
    color: #FFFFFF;
    background: #4D84FF;
  }
}

.esop-details-content {
  margin-top: 8px;
}

.forms-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vesting-schedule-form {
  margin-top: 8px;
}
</style>
